import { render, staticRenderFns } from "./game-row.vue?vue&type=template&id=45e39812"
import script from "./game-row.vue?vue&type=script&lang=js"
export * from "./game-row.vue?vue&type=script&lang=js"
import style0 from "./game-row.vue?vue&type=style&index=0&id=45e39812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports